// Hands the viewer a file: a Blob behind a temporary link, clicked.

export function download(name: string, parts: BlobPart[], mime: string): void {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob(parts, { type: mime }));
  a.download = name;
  document.body.append(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}
